import Grid from "@mui/material/Grid";
import { Fragment } from "react";
import { experienceLevels } from "../../../helpers/constant";
import SharedStaticPageHeader from "../../shared/SharedStaticPageHeader/SharedStaticPageHeader";
import {
  ContentContainer,
  LinkContainer,
  LinkStyled,
  TitleStyled,
  Wrapper,
} from "../styles";

const SpecialisationsAndExperienceLevelsContent = ({
  specialisations = [],
  experiences = [],
}) => {
  const combineExpList = experiences.map((experienceLevel, index) => ({
    ...experienceLevel,
    ...experienceLevels[index],
  }));

  return (
    <Wrapper>
      <SharedStaticPageHeader
        page={"Jobs by Specialisation and Experience Level"}
      />
      <Grid>
        <TitleStyled>Jobs by Specialisation and Experience Level</TitleStyled>
        <ContentContainer>
          {combineExpList.map((exp, index) => {
            return (
              <Fragment key={index}>
                {specialisations.map((spec, index) => {
                  return (
                    <Fragment key={index}>
                      {spec.subSpecialisations.map((sub, index) => {
                        return (
                          <LinkContainer key={index}>
                            <LinkStyled
                              href={`/jobs-in-${spec.slug}/${sub.slug}?experience=${exp.id}`}
                            >
                              {spec.name +
                                " - " +
                                sub.name +
                                " - " +
                                exp.experienceLevel}{" "}
                              jobs
                            </LinkStyled>
                          </LinkContainer>
                        );
                      })}
                    </Fragment>
                  );
                })}
              </Fragment>
            );
          })}
        </ContentContainer>
      </Grid>
    </Wrapper>
  );
};

export default SpecialisationsAndExperienceLevelsContent;
